import {MC_Device} from "../common/iot/MC_Device";

// Class to define what devices can be created
export interface CustomDevice {
    rawType: string,
    fullTypeName: string,
    description: string
}
// Create device
export class CustomDeviceFactory {

    // Devices
    public static TYPE_TH: string = "TH";
    public static TYPE_CO2: string = "CO2";
    public static TYPE_PRESSURE: string = "PRESSURE";
    public static TYPE_HRB: string = "HRB";
    public static TYPE_HBB: string = "HBB";
    public static FULL_TYPE_TH: string = "Temperature/Humidity Sensor";
    public static FULL_TYPE_CO2: string = "CO2 Sensor";
    public static FULL_TYPE_PRESSURE: string = "Pressure Sensor";
    public static FULL_TYPE_HRB: string = "WY Hydrant Red Box";
    public static FULL_TYPE_HBB: string = "WY Hydrant Black Box";

    public static SUPPORTED_DEVICES: CustomDevice[] = [
        {
            rawType: this.TYPE_TH,
            fullTypeName: this.FULL_TYPE_TH,
            description: ""
        },
        {
            rawType: this.TYPE_CO2,
            fullTypeName: this.FULL_TYPE_CO2,
            description: ""
        },
        {
            rawType: this.TYPE_PRESSURE,
            fullTypeName: this.FULL_TYPE_PRESSURE,
            description: ""
        },
        {
            rawType: this.TYPE_HRB,
            fullTypeName: this.FULL_TYPE_HRB,
            description: ""
        },
        {
            rawType: this.TYPE_HBB,
            fullTypeName: this.FULL_TYPE_HBB,
            description: ""
        }
    ];

    public static fromData(data: any): MC_Device {
        const type: string | null = (data[MC_Device.FIELD_TYPE] != null)
            ? data[MC_Device.FIELD_TYPE] as string
            : null
        ;
        if (type == null) {
            throw "Missing device type";
        }
        // Custom device types
        switch (type) {}
        // Return base device as default
        return new MC_Device(data);
    }

    public static getArrayFromData(dataArray: any[]): MC_Device[] {
        let devices: MC_Device[] = [];
        for (let i = 0; i < dataArray.length; i++) {
            try {
                devices = devices.concat(this.fromData(dataArray[i]));
            } catch (e) {
                console.error("Device parse err: " + e + ": " + JSON.stringify(dataArray[i]));
            }
        }
        return devices;
    }

    public static getFullDeviceType(type: string): string {
        switch (type) {
            case this.TYPE_TH: return this.FULL_TYPE_TH;
            case this.TYPE_CO2: return this.FULL_TYPE_CO2;
            case this.TYPE_PRESSURE: return this.FULL_TYPE_PRESSURE;
            case this.TYPE_HRB: return this.FULL_TYPE_HRB;
            case this.TYPE_HBB: return this.FULL_TYPE_HBB;
        }
        return "Unknown";
    }

}
